import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './user-account_types.2';

export function getUserName(variable?: null, options?: GqlRequestOptions) {
  const query = 'fragment UserAccountNamePart on UserAccount { full_name authenticated_name uuid } query GetUserName { user_account { ...UserAccountNamePart } }';
  return gql_request<types.GetUserName, null>('GetUserName', query, variable, { use_consumer: true, ...options });
}

export function getUserAccountKakaoConnected(variable?: null, options?: GqlRequestOptions) {
  const query = 'fragment UserAccountKakaoConnectedPart on UserAccount { kakao_connected } query GetUserAccountKakaoConnected { user_account { ...UserAccountKakaoConnectedPart } }';
  return gql_request<types.GetUserAccountKakaoConnected, null>('GetUserAccountKakaoConnected', query, variable, { use_consumer: true, ...options });
}

